export enum FeedbackEntity {
  AVATAR = "avatar",
  VIDEO = "video",
  AGENT = "agent",
  OUTREACH_CAMPAIGN = "campaign",
  CALL = "call",
}

export interface Feedback {
  id: string
  createdAt: string
  updatedAt: string
  creatorId: string
  rating: number
  feedback: string
  feedbackTopic: string
  contactConsent: boolean
  entityType: FeedbackEntity | null
  entityId: string | null
}
